import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePropertyDocumentByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Property_Documents_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdatePropertyDocumentByIdMutation = { __typename?: 'mutation_root', update_property_documents_by_pk?: { __typename?: 'property_documents', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed?: boolean | null, type?: string | null, description?: string | null, name?: string | null, property_id: any } | null };


export const UpdatePropertyDocumentByIdDocument = gql`
    mutation updatePropertyDocumentById($set: property_documents_set_input, $id: uuid!) {
  update_property_documents_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    photo_link
    document_link
    video_link
    audio_link
    site_link
    transcription
    transcribed
    type
    description
    name
    property_id
  }
}
    `;
export type UpdatePropertyDocumentByIdMutationFn = Apollo.MutationFunction<UpdatePropertyDocumentByIdMutation, UpdatePropertyDocumentByIdMutationVariables>;

/**
 * __useUpdatePropertyDocumentByIdMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyDocumentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyDocumentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyDocumentByIdMutation, { data, loading, error }] = useUpdatePropertyDocumentByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePropertyDocumentByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyDocumentByIdMutation, UpdatePropertyDocumentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyDocumentByIdMutation, UpdatePropertyDocumentByIdMutationVariables>(UpdatePropertyDocumentByIdDocument, options);
      }
export type UpdatePropertyDocumentByIdMutationHookResult = ReturnType<typeof useUpdatePropertyDocumentByIdMutation>;
export type UpdatePropertyDocumentByIdMutationResult = Apollo.MutationResult<UpdatePropertyDocumentByIdMutation>;
export type UpdatePropertyDocumentByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyDocumentByIdMutation, UpdatePropertyDocumentByIdMutationVariables>;